import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/item-page/item-page-data'

import { ItemPageDeleteActionModel } from '../types'

export const getItemPageDeleteActionPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageDeleteActionModel => ({
  id: itemDto.id,
  userId: itemDto.user.id,
  canDelete: itemDto.can_delete,
  isClosed: itemDto.is_closed,
})

export const getServerItemPageDeleteActionPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageDeleteActionModel => ({
  id: sidebarDto.id,
  userId: sidebarDto.seller_id,
  canDelete: sidebarDto.can_delete,
  isClosed: sidebarDto.is_closed,
})
